<div class="set-password-wrapper">
  <i2g-form-master
    *ngIf="form"
    class="form"
    [ngClass]="{ 'has-error': form.errors?.mustMatch }"
    [form]="form"
  >
    <i2g-input-field
      class="form-row"
      type="password"
      e2eId="password"
      fieldId="password"
      layoutDirection="column"
      [fieldControl]="password"
      [errorMessages]="passwordErrorMessage"
      [label]="'FORM.PASSWORD.NEW_LABEL' | translate"
    >
    </i2g-input-field>

    <i2g-input-field
      class="form-row"
      type="password"
      e2eId="confirmPassword"
      fieldId="confirmPassword"
      layoutDirection="column"
      [fieldControl]="confirmPassword"
      [errorMessages]="passwordErrorMessage"
      [label]="'FORM.CONFIRM_PASSWORD.LABEL' | translate"
    >
    </i2g-input-field>

    <i2g-error-message
      [errorMessage]="passwordErrorMessage.mustMatch.message | translate"
      [dirty]="form.dirty"
      [invalid]="form.errors?.mustMatch"
    >
    </i2g-error-message>

    <button
      class="set-password-action"
      i2gButton
      buttonStyle="emphasis"
      i2gTrackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
      (click)="submit()"
    >
      {{ 'ACTION.SAVE' | translate }}
    </button>
  </i2g-form-master>
</div>
